import { render, staticRenderFns } from "./ChangePassword1.vue?vue&type=template&id=2497519c&scoped=true"
import script from "./ChangePassword1.vue?vue&type=script&lang=js"
export * from "./ChangePassword1.vue?vue&type=script&lang=js"
import style0 from "./ChangePassword1.vue?vue&type=style&index=0&id=2497519c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2497519c",
  null
  
)

export default component.exports